import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    NavigationEnd,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { filter } from "rxjs/operators";
import { Globals } from "../../app.globals";
import { UserService } from "../user.service";

@Injectable()
export class UserAuth implements CanActivate, CanActivateChild {
    constructor(
        private router: Router,
        private service: UserService,
        private globals: Globals
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        return this.isAllowedAccess(route);
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.isAllowedAccess(childRoute);
    }

    private async isAllowedAccess(route): Promise<boolean> {
        let returnVal = false;

        try {
            var result = await this.service.getUser().toPromise();
            this.service.setUser(result);
            returnVal = true;
        } catch {
            if (route.routeConfig?.path == "privacy-policy") {
                returnVal = true;
            }
            else {
                this.router.navigateByUrl("/unauthorized");
            }
        }

        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((val) => {
                if (this.service.user)
                    if (
                        this.service.user.status == "Pending" &&
                        (val as any).url != "/account/password"
                    ) {
                        this.router.navigateByUrl("/account/password");
                    }
            });

        return returnVal;
    }
}
